import _ from "lodash"
import { forwardRef } from "react"

function translateAlign(align) {
  if (!align) return {}

  const alignment = {}
  align = align.toLowerCase()

  if (align.startsWith("t")) alignment.alignItems = "flex-start"
  if (align.startsWith("m")) alignment.alignItems = "center"
  if (align.startsWith("b")) alignment.alignItems = "flex-end"
  if (align.startsWith("stretch")) alignment.alignItems = "strecth"
  if (align.startsWith("baseline")) alignment.alignItems = "baseline"

  if (align.endsWith("l")) alignment.justifyContent = "flex-start"
  if (align.endsWith("c")) alignment.justifyContent = "center"
  if (align.endsWith("r")) alignment.justifyContent = "flex-end"
  if (align.endsWith("sb")) alignment.justifyContent = "space-between"
  if (align.endsWith("sa")) alignment.justifyContent = "space-around"
  if (align.endsWith("se")) alignment.justifyContent = "space-evenly"

  return alignment
}

const spacings = {
  none: '0rem',
  xxs: '0.1333rem',
  xs: '0.333rem',
  sm: '0.666rem',
  md: '1rem',
  lg: '1.333rem',
  xl: '1.666rem',
  xxl: '2rem',
}
function translateSpace(space) {
  if (spacings[space]) return spacings[space]
  if (_.isNumber(space)) return `${space}px`
  return space
}

function translateSpacing(space) {
  if (space.indexOf(' ') > -1)
    space = space.split(' ')

  if (_.isArray(space)) {
    const res = space.map(translateSpace).join(" ")
    return res
  }

  return translateSpace(space)
}

export const Row = forwardRef(function ({ children, align, gap, col, padding, margin, style, ...props }, ref) {
  padding = padding ? translateSpacing(padding) : null
  margin = margin ? translateSpacing(margin) : null
  gap = gap ? translateSpace(gap) : null

  return (
    <div
      ref={ref}
      style={{
        display: "flex",
        ...translateAlign(align),
        flex: col,
        gap,
        padding,
        margin,
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  )
})

export function Column(props) {
  const style = props.style || {}
  style.flexDirection ||= "column"
  return <Row {...props} style={style} />
}
